$(document).ready(function () {
  var interval = setInterval(function () {
    if ($(".template-product [data-loop-widget-selling-plan-group]").length > 0) {
      
      // Function to append custom elements
      function appendCustomElements() {
          // Add "per bag" after the price element
          $("[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price").each(function() {
              if ($(this).find('.additional-price-text').length === 0) {
                  $(this).append('<span class="additional-price-text">Total Bag</span>');
              }
          });
  
          // Add "+ Free Accessories" after the label element
          $("[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-label").each(function() {
              if ($(this).find('.subscription-label-additional-text').length === 0) {
                  $(this).append('<span class="subscription-label-additional-text">+ Free Accessories</span>');
              }
          });
  
          // Append "($1.30/serving)" using two spans after the price element
          $("[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price").each(function() {
              if ($(this).next('.subscription-price-per-serving').length === 0) {
                  $(this).after('<div class="subscription-price-per-serving">(<span class="subscription-price-amount">$1.30</span><span class="price-unit">/serving</span>)</div>');
              }
          });
        }
      
        // Initial setup
        $(".custom-loop-subscription-widget").css("display", "block");
        var appendWidgetFreeProduct = $(".subscription-widget-free-product-section");
        var appendWidget = $(".custom-loop-subscription-widget-inner");
        $(".loop-widget-container").after(appendWidgetFreeProduct);
        $(".pf-product-form [data-combined]").before(appendWidget);
  
        // Initial call to ensure elements are added when the script loads
          appendCustomElements();
      
        //Upsell variant option click
        $(document).on("click",".custom-loop-subscription-widget-flavour-box-cover label",function () {
            changeVariant($(this));
        });
        
        $(document).on("click",".custom-loop-subscription-widget-quantity label",function () {
            changeVariant($(this));
        });
 
  
        function changeVariant(element) {
          setTimeout(function () {
            var variantWrapper = element.closest(".custom-loop-subscription-widget-inner");
            
             var upsellFlavourOption = variantWrapper.find(".custom-loop-subscription-widget-flavour-box-cover input:checked").data("title");
             var upsellQtyOption = variantWrapper.find(".subscribe-Save-purchase--box input:checked").data("title");
             var comb = (upsellFlavourOption + " / " + upsellQtyOption);
            var selector = "[variant-title='" + comb + "']";
  
            var selectedOptionValue = element.closest(".custom-loop-subscription-widget-inner").find(".all-variants " + selector);
            if (selectedOptionValue.length) {
              var selectedVariantPrice = selectedOptionValue.data("variant-price");
              var selectedVariantID = selectedOptionValue.data("variant-id");
            }
            $('input[name="id"]').val(selectedVariantID);
  
          // If the option is found, select it and trigger the change event
          if (selectedOptionValue.length > 0) {
              var $pfVariantSelect = $("[data-combined] .pf-variant-select");
              $pfVariantSelect.val(selectedVariantID); // Set the selected value
              $pfVariantSelect.trigger("change"); 
          }
            
          }, 100);
        }
      
      // Function to be executed when changes are detected on widget
      const handleMutations = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            appendCustomElements();
          } else if (mutation.type === 'attributes') {
            appendCustomElements();
          }
        }
      };
      
      // Create an instance of MutationObserver and pass it the callback function
      const observer = new MutationObserver(handleMutations);
      
      // Define the target node and the observer options
      const targetNode = document.querySelector('.loop-widget-container'); // Replace with your target element's ID
      const config = { 
        childList: true,     // Observe direct children
        attributes: true,    // Observe attribute changes
        subtree: true        // Observe all descendants, not just direct children
      };
      
      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);


      //Start
        function toggleSubscriptionWidget() {
          if($('[data-loop-widget-selling-plan-group]').hasClass("loop-widget-purchase-option-selected")){
            $(".subscription-widget-free-product-section").show();
          }else {
            $(".subscription-widget-free-product-section").hide();
          }
        }
        toggleSubscriptionWidget();
        $(document).on("click", ".loop-widget-purchase-option", function() {
          toggleSubscriptionWidget();
        });
      //End
      clearInterval(interval);
    }
  }, 100);
});

(function () {
  /* BUG 007 */
  var CLOSE_ICON =
    '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
    '<path fill="#000000" d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"/>' +
    "</svg>";

  function getClickTarget(t) {
    if (!t) return null;
    return t.nodeType === 1 ? t : t.parentElement || null;
  }

  function closestFrom(t, sel) {
    var el = getClickTarget(t);
    return el && typeof el.closest === "function" ? el.closest(sel) : null;
  }

  function isVisible(el) {
    if (!el || el.hidden) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== "none" && cs.visibility !== "hidden";
  }

  function getOpenModals() {
    return Array.prototype.filter.call(
      document.querySelectorAll('[role="dialog"].pf-m, dialog.pf-dialog'),
      function (m) {
        if (m.hasAttribute("hidden")) return false;
        return isVisible(m);
      }
    );
  }

  function resetBodyScroll() {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    document.body.classList.remove("overflow-hidden", "pf-popup-open");
  }

  function isOverlayEl(el) {
    if (!el || !isVisible(el)) return false;
    return el.classList.contains("pf-overlay") || el.classList.contains("pf-m-overlay");
  }

  function removeOverlays() {
    document.querySelectorAll(".pf-overlay, .pf-m-overlay").forEach(function (el) {
      if (isVisible(el)) el.remove();
    });
  }

  /* --- Our close button lives in <body>, not inside the modal ---
     Uses unique class "nb-modal-close" to avoid clashing with
     PageFly's native .pf-close-btn inside the modal.            */
  var _btn = null;

  function getCloseBtn() {
    if (_btn && document.body.contains(_btn)) return _btn;
    _btn = document.createElement("button");
    _btn.className = "nb-modal-close";
    _btn.setAttribute("type", "button");
    _btn.setAttribute("aria-label", "Close");
    _btn.innerHTML = CLOSE_ICON;
    _btn.style.display = "none";
    _btn.addEventListener("click", function (e) {
      e.preventDefault();
      triggerClose();
    });
    document.body.appendChild(_btn);
    return _btn;
  }

  /* Position button just above the top-right corner of the open modal */
  function positionCloseBtn(modal) {
    var btn = getCloseBtn();
    if (!modal) return;
    var rect = modal.getBoundingClientRect();
    var btnSize = window.innerWidth <= 767 ? 44 : 40;
    var gap = 8;
    var top = rect.top - btnSize - gap;
    var rightFromEdge = window.innerWidth - rect.right;
    btn.style.top = Math.max(gap, top) + "px";
    btn.style.right = Math.max(gap, rightFromEdge) + "px";
  }

  function showCloseBtn() {
    var modal = getOpenModals()[0];
    positionCloseBtn(modal);
    getCloseBtn().style.display = "flex";
  }

  function hideCloseBtn() {
    if (_btn) _btn.style.display = "none";
  }

  /* Find PageFly's native close button — may be inside or sibling of modal */
  function findNativeCloseBtn(modal) {
    var btn = modal.querySelector(".pf-close-btn, .pf-close-dialog-btn");
    if (btn) return btn;
    var parent = modal.parentElement;
    if (parent) {
      btn = parent.querySelector(".pf-close-btn, .pf-close-dialog-btn");
      if (btn) return btn;
    }
    return null;
  }

  /* triggerClose: click PageFly's NATIVE button so its isOpen state
     updates properly. Supplement with overlay/scroll cleanup after. */
  function triggerClose() {
    hideCloseBtn();
    var modal = getOpenModals()[0];
    if (modal) {
      var nativeBtn = findNativeCloseBtn(modal);
      if (nativeBtn) {
        nativeBtn.click();
      } else if (typeof modal.close === "function") {
        try { modal.close(); } catch (ignore) {}
      } else {
        modal.style.display = "none";
        modal.setAttribute("aria-hidden", "true");
      }
    }
    window.setTimeout(function () {
      removeOverlays();
      resetBodyScroll();
      hideCloseBtn();
    }, 150);
  }

  /* MutationObserver: show/hide our button + clean up orphaned overlays */
  var _mutTimer;
  new MutationObserver(function () {
    clearTimeout(_mutTimer);
    _mutTimer = window.setTimeout(function () {
      var open = getOpenModals();
      if (open.length > 0) {
        showCloseBtn();
      } else {
        hideCloseBtn();
        removeOverlays();
        resetBodyScroll();
      }
    }, 150);
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "hidden"]
  });

  /* Capture phase: clear hidden so PageFly can show modal on reopen */
  document.addEventListener("click", function (e) {
    if (!closestFrom(e.target, '[data-action="modal"]')) return;
    document.querySelectorAll('[role="dialog"].pf-m, dialog.pf-dialog').forEach(function (m) {
      m.removeAttribute("hidden");
      m.removeAttribute("aria-hidden");
    });
  }, true);

  /* Bubble phase: overlay click or click outside open modal → close */
  document.addEventListener("click", function (e) {
    var el = getClickTarget(e.target);
    if (!el) return;
    if (closestFrom(el, ".nb-modal-close")) return;
    if (closestFrom(el, '[data-action="modal"]')) return;

    var open = getOpenModals();
    if (open.length === 0) return;

    var modal = open[0];
    var onOverlay = isOverlayEl(el);
    var outside = !modal.contains(el);

    if (onOverlay || outside) {
      triggerClose();
    }
  });

  /* Escape key */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && getOpenModals().length > 0) triggerClose();
  });

  /* Page-load: remove any stale overlay after PageFly finishes init */
  window.setTimeout(function () {
    if (getOpenModals().length === 0) {
      removeOverlays();
      resetBodyScroll();
    }
  }, 2000);
})();